const lensCountries: Record<string, string> = {
  ae: "United Arab Emirates",
  at: "Austria",
  au: "Australia",
  be: "Belgium",
  br: "Brazil",
  ca: "Canada",
  ch: "Switzerland",
  cl: "Chile",
  co: "Colombia",
  cz: "Czech Republic",
  de: "Germany",
  dk: "Denmark",
  es: "Spain",
  fr: "France",
  gb: "United Kingdom",
  id: "Indonesia",
  ie: "Ireland",
  in: "India",
  it: "Italy",
  jp: "Japan",
  kr: "Korea, Republic of",
  mx: "Mexico",
  my: "Malaysia",
  nl: "Netherlands",
  no: "Norway",
  nz: "New Zealand",
  ph: "Philippines",
  pl: "Poland",
  pt: "Portugal",
  ru: "Russian Federation",
  se: "Sweden",
  sg: "Singapore",
  tr: "Turkey",
  us: "United States",
  za: "South Africa",
};

const countryEmojis : Record<string, string> = {
  ae: "🇦🇪", at: "🇦🇹", au: "🇦🇺", be: "🇧🇪", br: "🇧🇷",
  ca: "🇨🇦", ch: "🇨🇭", cl: "🇨🇱", co: "🇨🇴", cz: "🇨🇿",
  de: "🇩🇪", dk: "🇩🇰", es: "🇪🇸", fr: "🇫🇷", gb: "🇬🇧",
  id: "🇮🇩", ie: "🇮🇪", in: "🇮🇳", it: "🇮🇹", jp: "🇯🇵",
  kr: "🇰🇷", mx: "🇲🇽", my: "🇲🇾", nl: "🇳🇱", no: "🇳🇴",
  nz: "🇳🇿", ph: "🇵🇭", pl: "🇵🇱", pt: "🇵🇹", ru: "🇷🇺",
  se: "🇸🇪", sg: "🇸🇬", tr: "🇹🇷", us: "🇺🇸", za: "🇿🇦"
}

const countries = Object.entries(lensCountries)
  .sort(([, a], [, b]) => a.localeCompare(b))
  .map(([key]) => {
    return { value: key, label: lensCountries[key], flag: countryEmojis[key] };
  });

export default countries;
